import type { FetchListParams } from 'Services/ProductManagement/types'

export enum SalesRuleTabType {
  DETAILS = 'details',
  PRODUCTS = 'products',
  ZONE_REQUIREMENTS = 'zone_requirements'
}

interface ExtensionArea {
  product_group: string
  zone_map: string[]
}

interface ZoneRequirement {
  zone_map: string[]
  required_one_of_existing_products: ExtensionArea[]
}

export interface SalesRule {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  name: string
  zone_requirements: ZoneRequirement[]
  product_codes: string[]
}

export interface FetchSalesRuleListParams extends FetchListParams {
  case_sensitive?: boolean
  zone_requirements?: string
}
